import styled from 'styled-components';
import ProgressBar from '@womcorp/wom-miwom-ui-kit/dist/components/Loader/ProgressBar';

const CurrentBalanceWrapperStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;

  ${({ hasProgressBar }) =>
    hasProgressBar &&
    `
  justify-content: flex-start;
  width: 100%;
  padding-left: 24px;
  padding-right: 24px;
`}
`;

const IconCurrentBalanceStyled = styled.img`
  margin-right: 8px;
`;

const ContentWrapperStyled = styled.div`
  ${({ hasProgressBar }) =>
    hasProgressBar &&
    `
  width: 100%;
`}
  h4 {
    color: black;
    font-weight: 500;
    font-size: 16px;
  }
`;

const ProgressBarStyled = styled(ProgressBar)`
  &.custom-progress {
    height: 8px;
  }
  &.custom-progress::-webkit-progress-value {
    background-color: #e92070;
    border-radius: 100px;
  }
`;

export {
  CurrentBalanceWrapperStyled,
  IconCurrentBalanceStyled,
  ContentWrapperStyled,
  ProgressBarStyled,
};
